import moment, {Moment} from 'moment'

const DEFAULT_DATE_FORMAT = 'DD MMM YYYY (HH:mm)'

export const formatDate = (date: string | Moment): string => {
    return date && moment(date).isValid() ? moment(date).format(DEFAULT_DATE_FORMAT) : 'N/A'
}
